import tw from "tailwind-styled-components";

const Card = ({ children }) => {
  return(
  <CardContainer>{ children }</CardContainer>
)};
const CardContainer = tw.div`bg-white rounded-2xl shadow-lg mx-4 md:my-2 md:w-96 md:mx-0 w-72 md:px-0 px-9 py-4 md:mb-0 md:mb-0 xl:ml-[700px] lg:ml-[500px] h-[590px] `
export default Card;
